module.exports = __webpack_public_path__ + "2bfcbdb4d9cf51a554f106ac2aefb9e5.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2018-03-04/whats-new.html
// module id = 2298
// module chunks = 0